import React from 'react';
import {OutletHeaderStyled} from "../../../styled/Resume";
import {useTheme} from "../../UI/Theme/ThemeContext";
import { LiaFileMedicalAltSolid } from "react-icons/lia";
import { FaUserEdit } from "react-icons/fa";



const DataHeader = ({activeStep, setActiveStep}) => {

    const {themeName} = useTheme();

    return (
        <OutletHeaderStyled active={activeStep} theme={themeName}>
            <ul className="headerOutlet">
                <li className="fromOld" onClick={()=>setActiveStep(1)}>
                    Optimize old resume <span className="icon"><LiaFileMedicalAltSolid/></span>
                </li>
                <li className="fromNew" onClick={()=>setActiveStep(2)}>
                    Create from scratch <span className="icon"><FaUserEdit/></span>
                </li>
            </ul>
        </OutletHeaderStyled>
    )
}

export default DataHeader;